import setupRoutes from '@/router/routes/admin-routes/setup-routes'
import designRoutes from '@/router/routes/admin-routes/design-routes'
import customerRoutes from '@/router/routes/admin-routes/customers-routes'

import managementRoutes from '@/router/routes/admin-routes/management-routes'
import marketingRoutes from '@/router/routes/admin-routes/marketing-routes'
import posRoutes from '@/router/routes/admin-routes/pos-routes'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import checkExpirationGuard from '@/router/guards/check-expiration-guard'
import USER_TYPES from '@/constants/authorization/user-types'
import HomeRedirect from '@/router/utils/home-redirect'
import fromRegisterGuard from '@/router/guards/from-register-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import checkRouteQueryGuard from '@/router/guards/check-route-query-guard'
import marketingGuard from '@/router/guards/marketing-guard'
import shortcutGuard from '@/router/guards/shortcut-guard'
import mobileRoutes from '@/router/routes/admin-routes/mobile-routes'
import fetchBusinessTypesGuard from '@/router/guards/fetch-business-types-guard'
import inventoryRoutes from '@/router/routes/admin-routes/inventory-routes'
import reports from '@/router/routes/admin-routes/reports'

export default [
  {
    path: '/admin',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkExpirationGuard, checkRouteQueryGuard, marketingGuard, shortcutGuard]),
    children: [
      {
        path: '',
        name: 'admin:home',
        redirect: HomeRedirect,
      },
      {
        path: 'dashboard',
        name: 'admin:dashboard',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/dashboard/DashboardView.vue'),
      },
      {
        path: 'devices',
        name: 'admin:display-devices',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/display-devices/DevicesTable.vue'),
      },
      {
        path: 'settings',
        beforeEnter: multiGuard([fetchBusinessTypesGuard]),
        name: 'admin:settings',
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/settings/SettingsForm.vue'),
      },
      {
        path: 'payment-links',
        name: 'admin:payment-links',
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/payment-links/PaymentLinks.vue'),
      },
      {
        path: 'branches-management',
        name: 'admin:branches-management',
        meta: { userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] },
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/branches-management/BranchesManagement.vue'),
      },
      {
        path: 'profile',
        name: 'admin:profile',
        component: () => import(/* webpackChunkName: "MyProfile" */ '@/views/admin/user/MyProfile.vue'),
      },
      {
        path: 'welcome',
        name: 'admin:welcome',
        beforeEnter: fromRegisterGuard,
        component: () => import(/* webpackChunkName: "welcome" */ '@/views/admin/welcome/WelcomeWizard.vue'),
      },
      {
        path: 'setup',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] },
        children: setupRoutes,
      },
      {
        path: 'design',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
        children: designRoutes,
      },
      {
        path: 'management',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR] },
        children: managementRoutes,
      },
      {
        path: 'marketing',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] },
        children: marketingRoutes,
      },
      {
        path: 'mobile',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
        children: mobileRoutes,
      },
      {
        path: 'customers',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
        children: customerRoutes,
      },
      {
        path: 'pos',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
        children: posRoutes,
      },
      {
        path: 'inventory',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER] },
        children: inventoryRoutes,
      },
      {
        path: 'reports',
        component: { render: (h: any) => h('router-view') },
        meta: { userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR] },
        children: reports,
      },
      {
        path: 'shortcuts',
        name: 'admin:shortcuts',
        component: () => import(/* webpackChunkName: "inventory" */ '@/@okmenu/components/cards/Shortcuts.vue'),
      },
    ],
  },

]
